import React, { useEffect } from 'react';

import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Gallery from '../sections/Gallery/Gallery';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';
import Therapy from '../sections/Therapy/Therapy';
import Appointment from '../sections/Appointment/Appointment';

const Services = () => {
    useEffect(() => {
        document.title =
            'Zahnmedizin & Leistungen in Bielefeld | Pankraz & Lichagin';

        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                'content',
                'Entdecken Sie unsere zahnmedizinischen Leistungen in Bielefeld: Zahnersatz, Prophylaxe, Wurzelbehandlung, Schienen, Aligner, Zahnästhetik und weitere Behandlungen.'
            );
    }, []);

    return (
        <>
            <Navbar />
            <ServiceBanner />
            <Therapy />
            <Gallery />
            <Appointment />
            <Footer />
        </>
    );
};

export default Services;